import { giphyBlue, giphyGreen, giphyPurple, giphyYellow } from '@giphy/colors'
import IGif from '@giphy/js-types/dist/gif'
import HoverOverlay from './hover'

type GifOverlayProps = {
    gif: IGif
    isHovered: boolean
}

const Overlay = ({ gif, isHovered }: GifOverlayProps) => {
    // Trending indicator
    let trendingIcon = null
    if (gif.tags?.includes('giphytrending')) {
        trendingIcon = <span className="inline-block w-4 h-4 rounded-full" style={{ background: giphyGreen }} />
    } else if (gif.tags?.includes('giphytrendingqueue')) {
        trendingIcon = <span className="inline-block w-4 h-4 rounded-full" style={{ background: giphyBlue }} />
    } else if (gif.tags?.includes('giphytrendingschedule')) {
        trendingIcon = <span className="inline-block w-4 h-4 rounded-full" style={{ background: giphyYellow }} />
    }

    // Border color for user type
    let borderColor = ''
    if (gif.user) {
        if (gif.user.user_type === 'partner') {
            borderColor = giphyPurple
        } else if (gif.user.is_verified || gif.user.user_type === 'artist') {
            borderColor = giphyYellow
        } else if ((gif.user as any).is_staff) {
            borderColor = giphyGreen
        }
    }

    return isHovered ? (
        <HoverOverlay gif={gif} />
    ) : (
        <div
            className="absolute bottom-0 left-0 w-full flex items-center justify-center"
            style={{
                borderBottom: borderColor ? `4px solid ${borderColor}` : undefined,
                minHeight: '32px',
            }}
        >
            {trendingIcon}
        </div>
    )
}

export default Overlay
